import React, { FC } from 'react'
import { Create, CreateProps, required, SimpleForm, TextInput } from 'react-admin'
import SectionTitle from '../../components/SectionTitle'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Styles } from '@material-ui/styles/withStyles'
import RouteBreadcrumbs from '../../components/RouteBreadcrumbs'
import { Helmet } from 'react-helmet'
import { WEB_APP_TITLE } from 'src/constants'

const styles: Styles<Theme, any> = {
  field: { maxWidth: 544 },
}

const useStyles = makeStyles(styles)

const CurrencyCreate: FC<CreateProps> = (props) => {
  const classes = useStyles(props)

  return (
    <>
      <Helmet title={`${WEB_APP_TITLE} - New currency`} />
      <RouteBreadcrumbs {...props} />
      <Create {...props}>
        <SimpleForm>
          <SectionTitle label="resources.global.fieldGroups.information" />
          <TextInput source="label" validate={required()} fullWidth className={classes.field} />
          <TextInput source="code" validate={required()} fullWidth className={classes.field} />
        </SimpleForm>
      </Create>
    </>
  )
}

export default CurrencyCreate
